var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "div",
    { staticClass: "mt-4" },
    [
      _vm._t("head"),
      _c("u", [
        _c(
          "a",
          _vm._g(
            {
              staticClass: "text-white",
              attrs: { href: "javascript:void(0)" }
            },
            {
              click: _vm.listeners.click ? _vm.listeners.click : function() {}
            }
          ),
          [_vm._t("default")],
          2
        )
      ]),
      _vm._t("tail")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }